import type { ReactNode } from "react";

/** Минимальный markdown для условий задач: абзацы, списки, **жирный**, `код`.
 *  Заголовок задачи рисуется отдельно, строки «## …» пропускаются. */
function inline(text: string): ReactNode[] {
  const parts = text.split(/(`[^`]+`|\*\*[^*]+\*\*)/g).filter(Boolean);
  return parts.map((p, i) =>
    p.startsWith("`") ? (
      <code key={i} className="rounded-sm bg-bg2 px-1 font-mono text-[12.5px] text-ink">
        {p.slice(1, -1)}
      </code>
    ) : p.startsWith("**") ? (
      <strong key={i} className="text-ink">
        {p.slice(2, -2)}
      </strong>
    ) : (
      p
    ),
  );
}

export function Markdown({ text }: { text: string }) {
  const blocks = text.replace(/^#+ .*$/gm, "").trim().split(/\n{2,}/);
  return (
    <div className="flex flex-col gap-2.5 text-[13.5px] leading-[1.6] text-ink2">
      {blocks.map((b, i) => {
        const lines = b.split("\n");
        if (lines.every((l) => /^\s*[-*] /.test(l))) {
          return (
            <ul key={i} className="m-0 list-disc pl-5">
              {lines.map((l, j) => (
                <li key={j}>{inline(l.replace(/^\s*[-*] /, ""))}</li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i} className="m-0">
            {inline(lines.join(" "))}
          </p>
        );
      })}
    </div>
  );
}
